import { FooterWrapper, FlexMenu } from "@smerth/gatsby-theme-theme-ui";
import menuData from "../../../../documentation/data/menu.yaml";
import * as React from 'react';
export default {
  FooterWrapper,
  FlexMenu,
  menuData,
  React
};